import React from 'react'
import { NotFoundPageComponent } from '../../components'

const NotFoundPage = () => {
  return (
    <div>
      <NotFoundPageComponent />
    </div>
  )
}

export default NotFoundPage
